import { useCommandDashboard } from '@/contexts/CommandDashboardContext'
import { DashboardSkeleton } from '@/components/dashboard/DashboardSkeleton'
import { LuxuryDashboardContent } from '@/components/dashboard/LuxuryDashboardContent'

export function LuxuryDashboard() {
  const { loading, error } = useCommandDashboard()

  if (loading) {
    return <DashboardSkeleton />
  }

  return <LuxuryDashboardContent apiError={error} />
}
